(function() {
	'use strict'

	const tabsForContollerActionsByElementClasses = {};
	var activeTab = null,
		tabsController = null,
		tabsContainer = null,
		preloaded = false;

	const tabInfoSchema = [
	];

	window.AppTabs = null;

	const NEVER             = 0;
	const ON_SHOW_TAB       = 1;
	const ON_OPEN_TAB       = 2;
	const ON_FIRST_OPEN_TAB = 3;

	const initAndShowDataTable = function(tab, data) {
		if ( data.dataTableArgs !== undefined && data.dataTableArgs != null ) {
			const args = data.dataTableArgs;
			data.dataTableArgs = null;
			delete data.dataTableArgs;
			data.tableId = args.tableId;
			args.container = tab.getContainer();
			data.defaultOrder = DataTablesManager.getDefaultSortOrder( args );
			DataTablesManager.createAndShowTable( args, t => data.dataTable = t );
		}
	}

	class Tab {
		constructor( { name, icon = null, text = null,
			create = undefined, controller = undefined, preload = undefined, actionElementClasses = undefined
		} ) {
			const data = { name, icon, text, create, controller, preload, open: false, toInit: true, dataTable: null, drawWhen: ON_OPEN_TAB };
			const tab = this;
			this.getName = function() { return data.name; }
			this.getIcon = function() { return data.icon; }
			this.getText = function() { return data.text; }
			this.getOpen = function() { return data.open; }
			this.getPreload = function() { return data.preload; }
			this.getIsActive = function() { return activeTab === this; }
			this.getController = function() {
				if ( data.controller !== undefined ) {
					return data.controller;
				} else if ( typeof data.create == 'function' ) {
					const create = data.create;
					const controller = create.call( this, {
						setController: function( value ) {
							return data.controller = value;
						},
						setDataTableArgs: function( value ) {
							if ( value.drawWhen !== undefined ) {
								switch ( value.drawWhen ) {
									case 'never': data.drawWhen = NEVER; break;
									case 'showTab': data.drawWhen = ON_SHOW_TAB; break;
									case 'openTab': data.drawWhen = ON_OPEN_TAB; break;
									case 'firstOpenTab': data.drawWhen = ON_FIRST_OPEN_TAB; break;
									default:
										data.drawWhen = value.drawWhen ? ON_OPEN_TAB : NEVER;
								}
								delete value.drawWhen;
							}
							return data.dataTableArgs = value;
						}
					} );
					delete data.create;
					if ( controller !== undefined ) {
						data.controller = controller;
					}
					return data.controller;
				}
				return undefined;
			}

			this.getContainer = function() {
				if ( data.container === undefined ) {
					data.container = Array.prototype.find.call(
						( tabsContainer || document ).getElementsByClassName( 'tab-content' ),
						element => element.dataset.name == data.name || element.id == data.name
					) || null;
					if ( ! data.container && tabsContainer ) {
						data.container = document.createElement( 'div' );
						tabsContainer.append( data.container );
						data.container.className = 'tab-content';
					}
				}
				return data.container;
			}

			this.drawTable = function() {
				if ( data.dataTableArgs !== undefined )
					initAndShowDataTable( tab, data );
				else if ( data.dataTable )
					data.dataTable.draw();
			}

			this.clearDrawTable = function() {
				if ( data.dataTableArgs !== undefined )
					initAndShowDataTable( tab, data );
				else if ( data.dataTable )
					data.dataTable.clear().draw();
			}

			this.clearTable = function() {
				if ( ! data.dataTable ) { return; }
				data.dataTable.clear();
				const table = document.querySelector( data.tableId );
				if ( table ) {
					const tbody = table.querySelector( 'tbody' );
					if ( tbody ) {
						while ( tbody.firstChild )
							tbody.removeChild(tbody.firstChild);
					}
				}
			}

			this.autofocus = function() {
				if ( data.container ) {
					const first = data.container.querySelector( 'input.first, select.first, .first input, .first select' );
					if ( first )
						first.focus();
				}
			};

			this.getDataTable = function() {
				return data.dataTable;
			};

			this.show = function(state = null) {
				if ( ! tabsController ) {
					console.log( 'missing tabs controller', { [ 'this' ]: this, tab, data } );
					return;
				}
				var openning = false;
				if ( activeTab != tab && activeTab != null ) {
					activeTab.container.style.display = 'none';
				}
				const switching = activeTab != tab;
				activeTab = tab;
				if ( ! data.open ) {
					openning = true;
					data.open = true;
					tabsController.openTabs.push( tab );
					document.scrollingElement.scrollTo( 0, 0);
				}

				// Forces create
				const controller = tab ? tab.controller : null || {};
				//console.log( { tab: this, data, controller } );

				if ( data.container ) {
					data.container.style.display = 'block';
					if ( data.container.parentElement != tabsContainer ) {
						tabsContainer.append( data.container );
					}
				}

				if ( data.drawWhen == ON_FIRST_OPEN_TAB )
					initAndShowDataTable( tab, data );

				if ( openning )
					tab.autofocus();

				if ( controller ) {
					if ( data.toInit ) {
						data.toInit = false;
						if ( typeof controller.onFirstOpenTab == 'function' )
							controller.onFirstOpenTab();
					}
					let newState = state || openning;
					if ( openning && typeof controller.onOpenTab == 'function' )
						newState = controller.onOpenTab( state ) || newState;
					if ( typeof controller.onShowTab == 'function' ) {
						newState = controller.onShowTab( openning, state ) || newState;
					} else if ( typeof controller.draw == 'function' ) {
						newState = controller.draw( state ) || newState;
					}
					const title = 'LIMS - ' + data.text;
					if ( undefined !== newState && null !== newState && false !== newState ) {
						const url = window.location.href.split('#')[0] + '#' + data.name;
						if ( null === state )
							history.pushState(newState, title, url);
						else if ( newState != state )
							history.replaceState(newState, title, url);
					}
					if ( document.title != title ) {
						document.title = title;
					}
					location.hash = data.name;
				}
				if ( ( data.drawWhen == ON_OPEN_TAB && openning ) || data.drawWhen == ON_SHOW_TAB ) {
					tab.drawTable();
				}
				tabsController.activeTab = tab;
				window.AppTabs.redraw();
			}

			this.drawTableShow = function() { tab.drawTable(); tab.show(); }

			this.showAndAutofocus = function() { tab.show(); tab.autofocus(); }

			this.showAll = function() { tab.drawTable(); tab.show(); tab.autofocus(); }

			this.close = function() {
				if ( ! tabsController ) { return; }
				const openTabs = tabsController.openTabs;
				const tabIndex = openTabs.indexOf( tab );
				// if this tab is not open, do nothing.
				if ( tabIndex < 0 ) {
					return;
				}
				const controller = tab.controller || {};
				if ( typeof controller.onCloseTab == 'function' ) {
					controller.onCloseTab();
				}
				tab.clearTable();
				if ( data.dataTable ) {
					try {
						data.dataTable.order( data.defaultOrder );
					} catch( e ) {} // ignore failing to reset order
					try {
						data.dataTable.columns().search( '' );
					} catch( e ) {} // ignore failing to clear search
					try {
						data.dataTable.search( '' );
					} catch( e ) {} // ignore failing to clear search
					const tr = data.dataTable.table().header().querySelector( 'tr.column-search' );
					if ( tr ) {
						for ( const input of tr.querySelectorAll('input') ) { input.value = ''; }
						for ( const select of tr.querySelectorAll('select') ) { select.selectedIndex = 0; }
					}
				}
				data.open = false;
				if ( data.container ) {
					data.container.style.display = 'none';
				}
				// if this tab is open and not active, close it.
				openTabs.splice( tabIndex, 1 );
				if ( tab != activeTab ) {
					return;
				}
				// if there is a new tab at the previous index, show it
				if ( openTabs.length > tabIndex ) {
					return openTabs[ tabIndex ].show();
				}
				// otherwise, if there is a tab before the closing tab, show it
				if ( openTabs.length ) {
					return openTabs[ tabIndex - 1 ].show();
				}
				// just clear the active tab
				activeTab = null;
				window.AppTabs.redraw();
			}

			if ( actionElementClasses instanceof Array ) {
				for ( const actionElementClass of actionElementClasses ) {
					if ( actionElementClass in tabsForContollerActionsByElementClasses ) {
						tabsForContollerActionsByElementClasses[ actionElementClass ].push( this );
					} else {
						tabsForContollerActionsByElementClasses[ actionElementClass ] = [ this ];
					}
				}
			}
		}

		get name() { return this.getName(); }

		get icon() { return this.getIcon(); }

		get text() { return this.getText(); }

		get open() { return this.getOpen(); }

		get isActive() { return this.getIsActive(); }

		get controller() { return this.getController(); }

		get container() { return this.getContainer(); }
	}

	const tabsByName = {};
	for ( const tab of tabInfoSchema ) {
		tabsByName[ tab.name ] = new Tab( tab );
	}

	class Tabs {
		getTab( tabName ) {
			const tab = tabsByName[ tabName ];
			if ( tab instanceof Tab ) { return tab; }
		}

		getTabController( tabName ) {
			const tab = tabsByName[ tabName ];
			if ( tab instanceof Tab ) { return tab.controller; }
		}

		showTab( tabName, state ) {
			const tab = tabsByName[ tabName ];
			if ( tab instanceof Tab ) { return tab.show( state ); }
		}

		closeTab( tabName ) {
			const tab = tabsByName[ tabName ];
			if ( tab instanceof Tab ) { return tab.close(); }
		}

		focusOnClientSelect(){
			if ( ! activeTab || ! activeTab.controller || ! activeTab.controller.$el ) { return false; }
			const clientSelects = activeTab.controller.$el.getElementsByClassName('clientSelect');
			if ( ! clientSelects || ! clientSelects.length ) { return false; }
			clientSelects[0].focus();
			return true;
		}

		// helper to determine if a tab is open
		isOpenTab( tabName ) {
			if ( ! tabsController ) { return false; }
			const tab = tabsByName[ tabName ];
			return tabsController.openTabs.findIndex( tab ) >= 0;
		}

		// Refresh the page so DataTables will be full width
		redraw() {
			setTimeout( function() {
				window.dispatchEvent( new Event('resize') );
			}, 10 );
		}

		refreshLocallyStoredData() {
			console.log( 'refresh locally stored data' );
			LocalStorageManager.clear();
			window.vmLoader.loadAllLocallyStoredData();
		}

		createTab( tab ) {
			if ( tab.name in tabsByName ) {
				console.error( 'app tab already created', tab, tabsByName[ tab.name ] );
				return;
			}
			const newTab = new Tab( tab );
			return tabsByName[ tab.name ] = newTab;
		}

		preload() {
			if ( preloaded ) { return; }
			preloaded = true;
			for ( const name of Object.getOwnPropertyNames( tabsByName ) ) {
				const tab = tabsByName[ name ];
				const preload = tab.getPreload()
				if ( preload ) {
					const controller = tab.controller;
					if ( typeof preload == 'string' ) {
						window[ preload ] = controller || tab;
					}
				}
			}
		}

		mount( controller, container = null ) {
			tabsController = controller;
			tabsContainer = container;
			if ( ! tabsContainer ) {
				const elements = document.getElementsByClassName( 'tabs-container' );
				if ( elements.length ) { tabsContainer = elements[0]; }
			}
			if ( tabsContainer ) {
				for ( const name of Object.getOwnPropertyNames( tabsByName ) ) {
					const tabContainer = tabsByName[ name ].container;
					if ( tabContainer ) {
						tabContainer.style.display = 'none';
					}
				}
			}
			this.preload();
		}

		forEachOpenTab( action ) {
			for ( const tab of openTabs )
				action( tab );
		}
	}

	window.AppTabs = new Tabs();

	window.addEventListener('hashchange', function() {
		console.log( 'hashchange', location.hash.substring(1) );
		if ( activeTab.getName() != location.hash.substring(1) )
			window.AppTabs.showTab( location.hash.substring(1), true );
	}, false);
	window.addEventListener('popstate', (event) => {
		console.log( 'popstate', location.hash.substring(1), event.state );
		window.AppTabs.showTab( location.hash.substring(1), event.state );
	  });

	document.addEventListener('keyup', event => {
		if ( ! activeTab || ! activeTab.controller || ( ! event.altKey && event.key != 'F4' ) ) { return; }
		// F4
		if ( event.key == 'F4' ) {
			event.preventDefault();
			event.stopPropagation();
			activeTab.focusOnClientSelect();
			return;
		}
		switch ( event.key ) {
			case 'n':
			case 'N':
				event.preventDefault();
				event.stopPropagation();
				if ( activeTab && typeof activeTab.controller.doCreateNew == 'function' ) {
					activeTab.controller.doCreateNew() && activeTab.focusOnClientSelect();
				}
				break;
			case 'l':
			case 'L':
				event.preventDefault();
				event.stopPropagation();
				if ( activeTab && typeof activeTab.controller.doLogin == 'function' ) { activeTab.controller.doLogin(); }
				break;
			case 'd':
			case 'D':
				event.preventDefault();
				event.stopPropagation();
				if ( event.ctrlKey && typeof activeTab.controller.doDuplicate == 'function' ) {
					activeTab && activeTab.controller.doDuplicate();
				}
				break;
			case 'p':
			case 'P':
				event.preventDefault();
				event.stopPropagation();
				if ( typeof activeTab.controller.doPartialCopy == 'function' ) {
					activeTab && activeTab.controller.doPartialCopy();
				}
				break;
			case 'c':
			case 'C':
				if ( event.altKey ) {
					event.preventDefault();
					event.stopPropagation();
					activeTab && activeTab.close();
				}
				break;
		}
	});

	document.addEventListener( 'click', event => {
		var target = event.target;
		// Use innermost <A>, <BUTTON>, or <INPUT> element
		while ( target.tagName != 'A' && target.tagName != 'BUTTON' && target.tagName != 'INPUT' ) {
			target = target.parentNode
			if ( target == null ) { return; }
		}
		for ( const elClass of target.classList ) {
			if ( elClass == 'tab-link' ) {
				event.preventDefault();
				const name = target.dataset[ 'tab' ];
				if ( name in tabsByName ) {
					tabsByName[name].show();
				}
			}
			if ( elClass in tabsForContollerActionsByElementClasses ) {
				event.preventDefault();
				for ( const tab of tabsForContollerActionsByElementClasses[ elClass ] ) {
					if ( typeof tab.controller.doElementAction == 'function' ) {
						tab.controller.doElementAction( target, elClass, event );
					}
				}
			}
		}
	} );

} )();
